<template>
  <section class="pt-8 mx-auto w-10/12">
    <div id="step1" class="columns-1 md:columns-2 lg:columns-3 gap-4">
      <div
        v-for="(templateDetails, index) in treatmentWiseTemplates"
        :key="index"
        class="break-inside-avoid inline-block w-full"
      >
        <table class="table rounded-lg bg-white w-full mb-3 shadow">
          <thead class="head">
            <tr>
              <th class="text-xl text-talternative-color text-left px-4 py-2">
                {{ templateDetails.TreatmentAreaDescription }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(template, index) in templateDetails.Templates" :key="index">
              <td
                @click="goToCreateAccountability(template.TemplateId)"
                class="cursor-pointer py-2 px-4 text-tdefault-color"
                :class="{ 'pb-4': index + 1 === templateDetails.Templates.length }"
              >
                {{ template.Naam }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!--Pop up to show stop license -->
    <generic-modal v-if="showPopUp">
      <template #header>
        Laden van machtiging is niet mogelijk
      </template>
      <template #body>
        <p>Het is helaas niet mogelijk om de machtiging automatisch in te laden. Wij verzoeken u daarom vriendelijk om de machtiging opnieuw in te vullen. Als u doorgaat zullen we de bestaande machtiging automatisch voor u stopzetten. Excuses voor het ongemak.</p>
      </template>
      <template #footer>
        <v-button tagelement="button" hollow md transparent class="cancelPopUp" @click="backToDashboard()">
          Annuleren
        </v-button>
        <v-button tagelement="button" md primary @click="closeLicense()"> Doorgaan </v-button>
      </template>
    </generic-modal>
  </section>
</template>
<script>
import router from '@/router';
import GenericModal from '@/components/shared/GenericModal';
import { navigateToAccountability } from '@/services';

import { useStore } from 'vuex';
import { computed, onMounted, onUnmounted } from 'vue';

export default {
  name: 'VNewauthorization',
  components: { GenericModal },
  setup() {
    const store = useStore();

    const treatmentWiseTemplates = computed(
      () => store.getters['accountability/getTreatmentAreaWiseAccountabilityTemplates']
    );
    
    const resetTreatmentAreaWiseTemplates = (value) =>
      store.commit('accountability/resetTreatmentAreaWiseTemplates', value);
    const setAccountabilities = (value) => store.commit('accountability/setAccountabilities', value);
    const setShowExtendLicensesBlock = (value) => store.commit('accountability/setShowExtendLicensesBlock', value);
    const startNewAccountability = (value) => store.dispatch('accountability/startNewAccountability', value);
    const setLicenseStopPopUpStatus = (value) => store.commit('accountability/setLicenseStopPopUpStatus', value);
    const showPopUp = computed(() => store.getters['accountability/getLicenseStopPopUpStatus']);
    const fetchAccountabilities = async () => await store.dispatch('accountability/fetchAccountabilities');

    onMounted(async () => {
      await fetchAccountabilities();
    });

    onUnmounted(() => {
      resetTreatmentAreaWiseTemplates();
      setAccountabilities([]);
    });
    const goToCreateAccountability = (id) => {
      setShowExtendLicensesBlock(false);
      startNewAccountability(id).then((response) => {
        navigateToAccountability(response.regular.accountabilityId);
      });
    };

    const backToDashboard = () => {
      router.push('/patientdashboard');
      setLicenseStopPopUpStatus(false);
    };

    const closeLicense = () => {
      setLicenseStopPopUpStatus(false);
    };

    return {
      treatmentWiseTemplates,
      showPopUp,
      resetTreatmentAreaWiseTemplates,
      setAccountabilities,
      setShowExtendLicensesBlock,
      startNewAccountability,
      setLicenseStopPopUpStatus,
      fetchAccountabilities,
      goToCreateAccountability,
      backToDashboard,
      closeLicense
    };
  }
};
</script>
